import { CSVBall } from 'classes/csv-ball';
import { CSVFormat, QualityError } from 'enums/csv';
import { PitchUploadStep, PitchUploaderTab } from 'enums/pitch-uploader';
import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { compact } from 'lodash';
import { create } from 'zustand';

type State = {
  step: PitchUploadStep;
  filename: Nullable<string>;
  format: Nullable<CSVFormat>;
  balls: CSVBall[];
  qualityWarnings: QualityError[];
  validationWarnings: string[];
  tab: PitchUploaderTab;
  activeID: Nullable<string>;
  animateKey: number; // ? this is a hack, b/c bs and traj get updated on balls w/o state changes
  /** Unsaved upload preview — blocks navigation via useBlocker while true */
  dirty: boolean;
};

type Actions = {
  // mostly for re-triggering any state-related stuff by re-setting the ball in the array
  updateBall: (v: CSVBall) => void;
  aggregateWarnings: (input?: CSVBall[]) => void;
  setDirty: (dirty: boolean) => void;
  reset: () => void;
};

type PitchUploaderStore = State & Actions;

export const usePitchUploaderStore = create<PitchUploaderStore>((set, get) => {
  return {
    step: PitchUploadStep.upload,
    filename: null,
    format: null,
    balls: [],
    qualityWarnings: [],
    validationWarnings: [],
    tab: PitchUploaderTab.Errors,
    activeID: null,
    animateKey: Date.now(),
    dirty: false,

    updateBall: (v) =>
      set((s) => ({
        balls: s.balls.map((b) => (b._id === v._id ? v : b)),
      })),

    aggregateWarnings: (input) => {
      const { balls } = get();

      const safeBalls = input ?? balls;

      const allWarnings = safeBalls.map((m) => m.getWarnings());

      set({
        validationWarnings: ArrayHelper.unique(
          compact(allWarnings.map((m) => m?.validation)).flat()
        ),
        qualityWarnings: ArrayHelper.unique(
          compact(allWarnings.map((m) => m?.quality)).flat()
        ),
      });
    },

    setDirty: (dirty) => set({ dirty }),

    reset: () => {
      set({
        step: PitchUploadStep.upload,
        filename: null,
        format: null,
        balls: [],
        tab: PitchUploaderTab.Errors,
        activeID: null,
        dirty: false,
      });
    },
  };
});
